import React, { useState, useCallback, useEffect, useMemo } from 'react'
import { m, LazyMotion, domAnimation } from "framer-motion"
import { EventCalendar } from './eventCalendar'
import { HeroCatalogCounter } from './heroCatalogCounter'
import { domainConverter, heroBannerEvent, getCustomerNumber } from '../../util/'
import { countdownBannerMockData } from './constants'
import { useGetCustomerCountdownBannerList } from '../../hooks'

export const HeroBanner = ({ appData:{customerdata}, appData:{storedata} }) => {
	const customerHeroBannerData = customerdata?.filter(data => data.contentType === "SchoolStoreHeroBanner")[0]

	const eventData = storedata?.schoolStoreEventsV2 && heroBannerEvent(storedata.schoolStoreEventsV2) ? heroBannerEvent(storedata.schoolStoreEventsV2) : false

	let schoolStoreHeroBannerImageUrl, extendedName, mascotUrl, mascotName, customerClassCode
	if (storedata && storedata.schoolStoreHeroBannerData) {
		schoolStoreHeroBannerImageUrl = storedata.schoolStoreHeroBannerData.schoolStoreHeroBannerImageUrl
		extendedName = storedata.schoolStoreHeroBannerData.extendedName
		mascotUrl = storedata.schoolStoreHeroBannerData.mascotUrl
		mascotName = storedata.schoolStoreHeroBannerData.mascotName
		customerClassCode = storedata.schoolStoreHeroBannerData.customerClassCode
	}
	const [isMascot, setIsMascot] = useState(mascotUrl)

	const isCollegeCustomer = customerClassCode?.indexOf('COLLEGE') !== -1
	const isCommercialCustomer = customerClassCode?.indexOf('COMMERCIAL') !== -1
	const showEnhancedHeroBannerType =  isCollegeCustomer || isCommercialCustomer 
	const heroBannerType = showEnhancedHeroBannerType ? 'enhanced':'slim'

	// Customer Countdown Banner 
	const customerNumber = getCustomerNumber()
	let customerCountdownBannerList = useGetCustomerCountdownBannerList(customerNumber)
	// set mock data for JCOM Test 1 customer [3157073]
	if (!customerCountdownBannerList || !customerCountdownBannerList.length) {
		customerCountdownBannerList = countdownBannerMockData[customerNumber]
	}
	// extend data with catalog property based on catalogOsr
	const countdownBannerListData = customerCountdownBannerList?.map(countdownEl => {
		countdownEl['catalog'] = storedata.productCatalogs.find(productCatalog => productCatalog.catalogOsr === countdownEl.catalogOsr)
		return countdownEl
	})
	// filter based on catalog availability
	.filter(countdownEl => countdownEl.catalog)
	const hasCountdownBanner = countdownBannerListData && countdownBannerListData.length > 0 
	
	const changeSchool = () => {
		document.getElementById("affiliate-change")?.click()
	}


	const onErrorHanddler = useCallback(
		() => {
			setIsMascot(false)
		},
		[],
	)

	const title = useMemo(() => {
		if (mascotName && mascotName !== 'null') {
			return `Hello, ${mascotName}!`
		} else if (!storedata && window.location.pathname.split("/")[5]) {
			return `Hello, ${window.location.pathname.split("/")[5].replace(/,/g, ' ')}!`
		} else {
			return 'Hello!'
		}
	}, [storedata])

	const heroImage = useMemo(()=>{
		if (eventData?.environment !== 'ONCAMPUS_APPT_EVENT' && eventData?.heroDesktopImgUrl) {
			return <img rel="preload" src={domainConverter(eventData.heroDesktopImgUrl)} alt="Banner background image" />
		} else if (customerHeroBannerData) {
			return (
				<picture>
					<source media="(min-width: 1200px)" srcSet={domainConverter(customerHeroBannerData.imageUrl.xl)} />
					<source media="(min-width: 1024px)" srcSet={domainConverter(customerHeroBannerData.imageUrl.lg)} />
					<source media="(min-width: 768px)" srcSet={domainConverter(customerHeroBannerData.imageUrl.md)} />
					<source media="(min-width: 576px)" srcSet={domainConverter(customerHeroBannerData.imageUrl.sm)} />
					<img rel="preload" src={domainConverter(customerHeroBannerData.imageUrl.xl)} alt={customerHeroBannerData && customerHeroBannerData.imageAltText} />
				</picture>
			)
		} else if (schoolStoreHeroBannerImageUrl) {
			return <img rel="preload" loading="eager" src={domainConverter(schoolStoreHeroBannerImageUrl)} alt="Banner background image" />
		} else {
			return null
		}
	}, [eventData, customerHeroBannerData])

	return (
		<LazyMotion features={domAnimation}>
			{heroBannerType === 'enhanced' &&
				<div
					className={`school-banner${(!eventData && !hasCountdownBanner ? ' no-event' : '')}`}
				>
					<div className="img-wrapper">
						{ heroImage }
					</div>
					<m.div
						className="overlay"
						animate={{
							opacity: [0, 1],
							transition: {
								duration: .5
							}
						}}
					>
						<div className="inner">
							<m.div
								animate={{
									opacity: [0, 1],
									transition: {
										delay: .5,
										duration: .5,
									},
								}}
								className={ isMascot ? "logo" : "logo no-logo"}
							>
								{
									isMascot && <img src={domainConverter(mascotUrl)} onError={onErrorHanddler} alt="School Mascot" height="auto" width="100%"/>
								}
							</m.div>
							<div>
								<m.h1
									animate={{
										y: [15, 0],
										opacity: [0, 1],
										transition: {
											delay: .8,
											duration: .3,
										},
									}}
								>
										{ title }
								</m.h1>
								<ul>
									<m.li
										animate={{
											y: [15, 0],
											opacity: [0, 1],
											transition: {
												delay: 1.1,
												duration: .3,
											},
										}}
									>
											{ extendedName }
									</m.li>
								</ul>
								<div id ="change-school-herobanner" >
									<a href="#affiliate" className="change-school" onClick = {changeSchool} >Change  School</a>
								</div>
							</div>
						</div>
						{ hasCountdownBanner 
							? <HeroCatalogCounter countdownBannerList={countdownBannerListData} /> 
							: eventData 
								? <EventCalendar eventData={eventData} /> 
								: null
						}
					</m.div>
				</div>
			}
			{heroBannerType === 'slim' &&
				<div className={`slim-school-banner${(!eventData && !hasCountdownBanner ? ' no-event' : '')}`} >
					<div className="inner">
						<div className={ isMascot ? "logo" : "logo no-logo"}>
							{
								isMascot && <img src={domainConverter(mascotUrl)} onError={onErrorHanddler} alt="School Mascot" height="auto" width="100%"/>
							}
						</div>
						<div>
							<h1>{ title }</h1>
							<ul>
								<li>{ extendedName }</li>
							</ul>
							<div id ="change-school-herobanner" >
								<a href="#affiliate" className="change-school" onClick = {changeSchool} >Change  School</a>
							</div>
						</div>
					</div>
					{ hasCountdownBanner 
						? <HeroCatalogCounter countdownBannerList={countdownBannerListData} /> 
						: eventData 
							? <EventCalendar eventData={eventData} /> 
							: null
					}
				</div>
			}
		</LazyMotion>
	)
}

export default HeroBanner